<form name="cpfModal" ng-submit="$ctrl.cadastrarLoginUnificado(cpfModal)">
  <div class="modal-header">
    <h3 class="modal-title">Complete seu cadastro</h3>
  </div>
  <div class="modal-body">
    <p>
      Em virtude de algumas mudanças que estamos preparando para o Aqila, precisaremos
      que você complete seu cadastro informando seu CPF. Isso trará futuramente muito
      mais facilidade para todos os usuários dos sistemas da Agro1.
    </p>
    <p>Agradecemos pela compreensão!</p>
    <div class="form-group">
      <label for="modal-cpf" class="control-label">CPF:</label>
      <input ng-model=$ctrl.usuario.cpf type="text" text-mask="$ctrl.CPF_MASK" 
             class="form-control" id="modal-cpf" placeholder="999.999.999-99"
             ng-change="$ctrl.resetErrors()" required name="cpf"
	     ng-disabled="$ctrl.loading">
      <span ng-repeat="erroCPF in $ctrl.erroCPFLoginUnificado">
        {{erroCPF}}
      </span>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-white" type="button" ng-disabled="$ctrl.loading" ng-click="$ctrl.close()">Cancelar</button>
    <button class="btn btn-primary" type="submit" ng-disabled="cpfModal.cpf.$invalid || $ctrl.loading">
      OK
      <span ng-show="$ctrl.loading">
        <i class="fa fa-spinner fa-spin"></i>
      </span>
    </button>
  </div>
</form>
